import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export function getPolls(query = {}) {
  return fetch(getUrl('/polls'), { query });
}

export function getMultiplePolls(ids = []) {
  return fetch(getUrl('/polls/many'), {
    query: { ids: ids.join(',') },
  });
}

export function getPoll(pollId) {
  return fetch(getUrl(`/polls/${pollId}`));
}

export function getTags() {
  return fetch(getUrl('/polls/tags'));
}
